module.exports = __webpack_public_path__ + "static/media/Rolling.62e272cb.svg";


//////////////////
// WEBPACK FOOTER
// ./src/Rolling.svg
// module id = 103
// module chunks = 0